const meetingsJSON = require('../mock-data/engage-meetings.json');
const studentsJSON = require('../mock-data/students.json');
const advisorsJSON = require('../mock-data/advisors.json');
const roomsJSON = require('../mock-data/engage-rooms.json');
const reasonsJSON = require('../mock-data/engage-meeting-reasons.json');

for (let i = 0; i < meetingsJSON.length; i++) {
    if (meetingsJSON[i].advisorId != null) meetingsJSON[i].advisor = advisorsJSON.find(a => a.id === meetingsJSON[i].advisorId);
    if (meetingsJSON[i].studentId != null) meetingsJSON[i].student = studentsJSON.find(s => s.id === meetingsJSON[i].studentId);
    if (meetingsJSON[i].roomId != null) meetingsJSON[i].room = roomsJSON.find(r => r.id === meetingsJSON[i].roomId);
    if (meetingsJSON[i].reasonId != null) meetingsJSON[i].reasonId = reasonsJSON.find(r => r.id === meetingsJSON[i].reasonId);
}

class MockMeetingService {
    getMeetingsForRoom() {
        return meetingsJSON;
    }
}

export default new MockMeetingService();



// WEBPACK FOOTER //
// ./src/mocks/mock-json-services/meeting.service.js